import { jsx as r } from "react/jsx-runtime";
import e from "../base-button.mjs";
const c = (o) => /* @__PURE__ */ r(
  e,
  {
    color: "text-background-secondary",
    hoverColor: "hover:text-background-secondary",
    backgroundColor: "bg-green",
    hoverBackgroundColor: "hover:bg-green",
    ...o
  }
);
export {
  c as SuccessButton
};
